<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.tcOrderStatus === 'D' || row.tcOrderStatus === 'R'
              ? 'warning'
              : row.tcOrderStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_tcOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="openEditPage({ pageType: 'detail', row })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M') && row.tcOrderStatus === 'N'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openEditPage({ pageType: 'edit', row })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_export') || '导出'"
            placement="top"
            v-if="allow('E') && row.tcOrderStatus === 'Y'"
          >
            <i class="el-icon-download tool-btn" @click="exportData(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D') && row.tcOrderStatus === 'N'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-if="allow('C') && row.tcOrderStatus === 'N'"
          >
            <i class="el-icon-circle-check tool-btn" @click="audit(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({ pageType, row = {} }) {
      const { tcOrderCode, tcOrderNo } = row
      this.$router.push({
        name: 'tc-scmOrder-detail',
        params: { code: tcOrderCode, pageType },
        query: { tcOrderNo },
      })
    },
    audit({ tcOrderCode }) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否要提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .tcOrderInfoReviewApi({ tcOrderCode })
            .then(() => {
              this.loadingClose()
              this.$message({
                showClose: true,
                message:
                  this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
                type: 'success',
              })
              this.$emit('reload')
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    del({ tcOrderCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.tcOrderInfoDelApi({ tcOrderCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    async exportData({ tcOrderCode }) {
      const params = { tcOrderCode }
      this.loadingOpen()
      const checkRes = await this.$api
        .tcOrderInfoExportCheckApi(params)
        .catch(() => null)

      const { status, msg } = checkRes || {}
      if (status != 200) {
        this.loadingClose()
        this.$message.error(msg)
        return
      }

      const exportRes = await this.$api
        .SYS_EXPORT_TASK('factory-tc-order-contract', params)
        .catch(() => null)
      this.loadingClose()
      const { status: exportStatus } = exportRes || {}
      if (200 !== exportStatus) {
        this.$message.error(
          this.$l('INDEX.Description_Failed_to_add_export_task') ||
            '导出任务添加失败'
        )
        return
      }
      this.$message({
        message:
          this.$l('INDEX.added_to_the_download_center') ||
          '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
        type: 'success',
      })
    },
  },
}
</script>
